// combatpro/runtime/MigrationModal.js
//
// Combat PRO - one-time save-authority migration (final persistence correction).
// Shown only when an account's existing populated encounters exceed its plan's
// durable capacity. The DM chooses which encounters remain Saved (up to the plan's
// per-family and total caps); encounters not kept are released from durable cloud
// storage on the next save (never silently deleted - the choice is explicit). Until
// this is confirmed, nothing is stripped, so no data is lost. No optional chaining.
// No nullish coalescing. No em dash.

import React, { useState } from 'react';
import { listPopulatedSlots } from '../encounter/encounterStoreEngine';

function keyOf(p) { return p.family + ':' + p.index; }
function famLabel(f) { return f.charAt(0).toUpperCase() + f.slice(1); }

function MigrationModal(props) {
  var ctx = props.ctx;
  var store = ctx.state.encounterStore;
  var ent = ctx.state.entitlement ? ctx.state.entitlement : { perFamily: 2, total: 2, cloud: false };
  var pop = listPopulatedSlots(store);

  var selHook = useState(function () {
    var chosen = {};
    var per = { standard: 0, random: 0, wave: 0 };
    var total = 0;
    for (var i = 0; i < pop.length; i++) {
      var p = pop[i];
      if (per[p.family] < ent.perFamily && total < ent.total) { chosen[keyOf(p)] = true; per[p.family] += 1; total += 1; }
    }
    return chosen;
  });
  var sel = selHook[0];
  var setSel = selHook[1];

  function currentCounts() {
    var per = { standard: 0, random: 0, wave: 0 };
    var total = 0;
    Object.keys(sel).forEach(function (k) { var fam = k.split(':')[0]; per[fam] += 1; total += 1; });
    return { per: per, total: total };
  }

  function toggle(p) {
    var k = keyOf(p);
    setSel(function (prev) {
      if (prev[k]) { var n = Object.assign({}, prev); delete n[k]; return n; }
      var per = { standard: 0, random: 0, wave: 0 };
      var total = 0;
      Object.keys(prev).forEach(function (kk) { var fam = kk.split(':')[0]; per[fam] += 1; total += 1; });
      if (per[p.family] >= ent.perFamily || total >= ent.total) { return prev; }
      var nn = Object.assign({}, prev); nn[k] = true; return nn;
    });
  }

  function confirm() {
    var selected = Object.keys(sel).map(function (k) { var parts = k.split(':'); return { family: parts[0], index: parseInt(parts[1], 10) }; });
    ctx.resolveMigration(selected);
  }

  var counts = currentCounts();

  return (
    <div className="cp-migrate-overlay" role="dialog" aria-modal="true">
      <div className="cp-migrate-box">
        <h3 className="cp-migrate-title">Choose your saved encounters</h3>
        <div className="cp-migrate-intro">
          {'Your Combat PRO plan keeps '}<b>{ent.perFamily}</b>{' saved encounters per family (Standard, Random, Wave) and '}<b>{ent.total}</b>{' in total. You have more prepared encounters than that. Pick the ones to keep as durable cloud saves; the rest stay available this session but will not be kept in cloud storage after your next change.'}
        </div>
        <div className="cp-migrate-counts">
          <span>{'Standard '}<b>{counts.per.standard + '/' + ent.perFamily}</b></span>
          <span>{'Random '}<b>{counts.per.random + '/' + ent.perFamily}</b></span>
          <span>{'Wave '}<b>{counts.per.wave + '/' + ent.perFamily}</b></span>
          <span>{'Total '}<b>{counts.total + '/' + ent.total}</b></span>
        </div>
        <div className="cp-migrate-list">
          {pop.map(function (p) {
            var k = keyOf(p);
            var checked = !!sel[k];
            return (
              <label className="cp-migrate-row" key={k}>
                <input type="checkbox" checked={checked} onChange={function () { toggle(p); }} />
                <span className="cp-migrate-fam">{famLabel(p.family) + ' ' + (p.index + 1)}</span>
                <span className="cp-migrate-name">{p.name}</span>
              </label>
            );
          })}
        </div>
        <div className="cp-migrate-actions">
          <button type="button" className="cp-gen-generate" onClick={confirm}>Keep selected as saved</button>
        </div>
        <div className="cp-migrate-foot">Combat PRO Cloud raises these limits. Nothing is deleted until you confirm.</div>
      </div>
    </div>
  );
}

export default MigrationModal;
